import React, { Component } from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect,
  Switch
} from 'react-router-dom'
import {
  MuiThemeProvider,
  MenuItem
} from 'material-ui';
import darkBaseTheme from 'material-ui/styles/baseThemes/darkBaseTheme';
import lightBaseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import Appbar from 'muicss/lib/react/appbar';

import { Top } from './top.js'
import { C93 } from './c93.js'
import { C92 } from './c92.js'
import { Test } from './components/Test'
import { About } from './components/About'
import Cookies from 'universal-cookie';

// Appbar+Drawerでサイドメニューは実現できそう
const Header = () => (
  <header>
    <h1>秋葉原モテ研究所</h1>
      {this.state && (
        <Appbar>
          <MenuItem containerElement={<Link to="/" />}>Home</MenuItem>
          <MenuItem containerElement={<Link to="/about" />}>About</MenuItem>
          <MenuItem containerElement={<Link to="/logout" />}>Logout</MenuItem>
        </Appbar>
      ) || (
        <Appbar>
          <MenuItem containerElement={<Link to="/" />}>Top</MenuItem>
          <MenuItem containerElement={<Link to="/about" />}>About</MenuItem>
          <MenuItem containerElement={<Link to="/login" />}>Login</MenuItem>
        </Appbar>
      )}
  </header>
)

export class Serial extends Component {
  constructor(props) {
    super(props);
    const cookies = new Cookies();
    cookies.set("serialNo", this.props.match.params.serial)
    console.log("<Serial>")
    console.log(cookies.getAll())
  }
  render() {
    return (
      <Redirect to="/c92"/>
    )
  }
}

export class C93Serial extends Component {
  constructor(props) {
    super(props);
    const cookies = new Cookies();
    cookies.set("serialNo", this.props.match.params.serial)
    console.log("<Serial>")
    console.log(cookies.getAll())
  }
  render() {
    return (
      <Redirect to="/c93"/>
    )
  }
}

// メインルータの動作
// About => About
// 未ログイン/ => Login
// 未ログイン/商品名/:serial => Login(props.serial = :serial)
// ログイン中/ => HOME
// ログイン中/商品名 => シリアルコード入力画面
// ログイン中/商品名/:serial => ダウンロード検証コンポーネント

// # Wants
// 未ログイン/商品名 => サンプル画像表示?

class App extends Component {
  render() {
    return (
      <MuiThemeProvider muiTheme={getMuiTheme(lightBaseTheme)}>
        <Router>
          <div>
            <Route component={Header}/>
            <Switch>
              <Route path="/about" component={About}/>
              <Route path="/test" component={Test}/>
              <Route path="/:serial" component={Serial}/>
              <Route path="/" component={Top}/>
            </Switch>
          </div>
        </Router>
      </MuiThemeProvider>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js